import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    DialogProps,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { matchIsValidTel } from "mui-tel-input";
import PhoneNumberInput from "src/components/forms/PhoneNumberInput";

interface Props extends Omit<DialogProps, "onClose"> {
    onSave: (phone: string) => void | Promise<void>;
    onRemindLater: () => void;
}

const schema = Yup.object().shape({
    phone: Yup.string()
        .required("Please enter phone number")
        .test("valid", "Please enter a valid phone number", (value) =>
            matchIsValidTel(value || "")
        ),
});

const PhoneReminderDialog = ({ onSave, onRemindLater, ...rest }: Props) => {
    return (
        <Dialog maxWidth="xs" fullWidth {...rest}>
            <Formik
                initialValues={{ phone: "" }}
                validationSchema={schema}
                onSubmit={async ({ phone }) => {
                    await onSave(phone);
                }}
            >
                {({ isSubmitting, isValidating }) => (
                    <Form>
                        <DialogTitle id="phone-reminder-title">
                            Add your phone number
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Get trip notifications via SMS
                            </DialogContentText>
                            <PhoneNumberInput
                                fullWidth
                                margin="dense"
                                name="phone"
                                label="Phone Number"
                                autoComplete="tel"
                                sx={{ mt: 2 }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onRemindLater}>Remind me later</Button>
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                loading={isSubmitting || isValidating}
                            >
                                Save
                            </LoadingButton>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default PhoneReminderDialog;
